import { Box, GridItem, Text } from "@chakra-ui/react";
import axios from "axios";
import { useState } from "react";
import { FileIcon } from "../../assets/svgs/Icons";
import { toast } from "react-toastify";

export const DocumentViewerLink = (props) => {
  const { referenceId, document, doc_from } = props;
  const { loading, setLoading } = useState("");

  // api call
  const getPresignedUrl = async (documentId, doc_type) => {
    const token = localStorage.getItem("cu_user");
    const values = {
      documentId: documentId,
      doc_type: doc_type,
      referenceId: referenceId,
      doc_from: doc_from
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_HOST}/api/document/getsignurl`,
        values,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.status === 200) {
        const presignedUrl = response?.data?.data;

        window.location.href = presignedUrl;
      } else {
        console.error("somthing went wrong while downloading document");
      }
    } catch (error) {
      console.error("Error While fetching document");
      toast.error("Error fetching document, Please try again later.")

    }
  };

  return (
    <>
      <Box>
        {document ? (
          document?.map((report, index) => (
            <Text
              textDecoration="underline"
              color="#2272D5"
              cursor="pointer"
              textOverflow="ellipsis"
              onClick={() => getPresignedUrl(report?._id, report?.doc_type)}
            >
              {report?.name || report?.doc_type}
            </Text>
          ))
        ) : (
          <Text>No report available</Text>
        )}
      </Box>
    </>
  );
};
